<template>
    <div>
        <st-button
            v-can:create="'complain'"
            variant="secondary"
            :callback="addComplain"
        >
            <i class="fa fa-plus"></i>
            {{ $t('COMPLAIN.LIST.ADD_BUTTON') }}
        </st-button>
    </div>
</template>

<script>
    export default {
        name: 'ComplainListToolbar',
        methods: {
            addComplain() {
                this.$router.push({ name: 'complainNew' });
            },
        },
    };
</script>

